import { graphql } from "api/cms-website/generated";

export const ListWithCTAFragment = graphql(/* GraphQL */ `
    fragment ListWithCTAFragment on ComponentComponentsListWithCta {
        id
        noMarginBottom
        listWithCtaTitle: title
        listWithCtaText: text
        listWithCtaItems: items {
            text
            icon {
                ...IconFragment
            }
        }
        listWithCtaCta: cta {
            ...ButtonFragment
        }
    }
`);
